import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import React, { useEffect, useState } from 'react';
import '../../components/ContactSection.css';
import './DonateDetailsSection.css';
import upIcon from "../../assets/images/up.png";

export const DonateDetailsSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    // This useEffect listens to the window scroll event
    useEffect(() => {
        window.scrollTo(0, 0);

        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const jumpHome = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="contactSection" id="contactsSectionId">
            <div className="masthead-donate">
                <div className="logo-services">
                    <h1 className="logo-services-title">Donate</h1>
                </div>
            </div>
            {isVisible && (
                <button className="floatingButton" onClick={jumpHome}>
                    <img className="up" src={upIcon} alt="up arrow icon" />
                </button>
            )}
            <Container>
                <Row>
                    <Col className="steakCol" sm={12} lg={12}>
                        <div className="emailCard-donate-main-donate">
                            <p className="mainTitle-donate">Donate</p>
                            <p className="donationBlurb-donate">
                                Thank you for considering donating towards the Streetlink Homeless Supports mission.
                                <br/><br/>SHS is a voluntary run organisation, so one hundred percent of your donation
                                goes towards
                                providing for our service users; who are some of the most vulnerable people within our
                                society today.
                                <br/><br/>
                                All our finances are recorded and administered by registered accountants at:<br/>
                                Vision Chartered Accountants, Sutton. Telephone: <a className="donateLink-donate"
                                                                                    href="tel:015411110">01-541-1110</a>
                                <br/><br/>
                                RCN: 20206746 | CHY: 23218
                            </p>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={12}>
                        <div className="emailCard-idonate">
                            <h2>IDonate</h2>
                            <br />
                            <a className="contactLinks-donate" target="_blank" rel="noreferrer" href="https://www.idonate.ie/cause/streetlinkhomelesssupport">https://www.idonate.ie/cause/streetlinkhomelesssupport</a>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={6}>
                        <div className="emailCard-donate">
                            <h2>Bank Transfer</h2>
                            <br />
                            <p className="contactLinks">
                                Bank Of Ireland, Sutton. <br />
                                Streetlink Homeless Support CLG <br />
                                ACC No: 55504396<br />
                                Sort Code: 900690<br />
                                IBAN No: IE58BOFI90069055504396<br />
                                BIC No: BOFIIE2D<br />
                            </p>
                        </div>
                    </Col>

                    <Col className="contactCol" sm={12} lg={6}>
                        <div className="emailCard-donate">
                            <h2>Cheque or Postal Order to:</h2>
                            <br />
                            <p className="contactLinks">
                                Payable to,<br />
                                Streetlink Homeless Support CLG<br />
                                Suite 11103<br />
                                26/27 Upper Pembroke Street<br />
                                Dublin 2<br />
                                D02X361<br />
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <br />
            <h4>Copyright 2025 Streetlink Homeless Support.</h4>
            <br />
        </div>
    );
}
